const editorConfig = {
    readonly: false,
    width: "100%",
    toolbar: true,
    language: "bn",
    allowIframe: true,
    safeHTML: false,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    processPasteHTML: true,
    processPasteFromWord: true,
    defaultActionOnPaste: "insert_as_html",
    enableDragAndDropFileToEditor: true,
    uploader: {
        insertImageAsBase64URI: true,
    },
    showPlaceholder: true,
    placeholder: "Start writing your content here...",
    beautifyHTML: true,
    observer: {
        timeout: 100,
    },
    style: {
        wordWrap: "break-word",
        whiteSpace: "normal",
        overflowWrap: "break-word",
    },
    pasteHTMLActionList: [
        { value: "insert_clear_html", text: "Insert as Text" },
        { value: "insert_as_html", text: "Insert as HTML" },
        { value: "insert_only_text", text: "Insert only Text" },
    ],
};

export default editorConfig;
